const footerLinks = [
  { id: "overview", label: "影片概览" },
  { id: "content", label: "完整版内容" },
  { id: "versions", label: "版本差异" },
  { id: "quality", label: "高清画质" },
  { id: "faq", label: "常见问题" },
  { id: "guide", label: "观影提示" },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          <div className="md:col-span-6">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-lg bg-accent-500 text-primary-950 flex items-center justify-center">
                <i className="ri-film-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-semibold text-background-50">
                姐姐的朋友电影
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-100/80 max-w-md">
              本站围绕“姐姐的朋友电影”整理完整版、未删减、无删减版与高清完整资源相关的名词说明与观看提示，
              目的是帮助浏览者更清楚地理解各类版本说法，内容仅作信息参考。
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-base font-semibold text-background-50">页面分区</h4>
            <ul className="mt-4 space-y-2">
              {footerLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    className="text-sm text-background-100/80 hover:text-accent-300 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-base font-semibold text-background-50">关键词方向</h4>
            <div className="mt-4 flex flex-wrap gap-2">
              {["完整版", "未删减", "无删减版", "高清完整版", "完整资源"].map((tag) => (
                <span
                  key={tag}
                  className="px-2.5 py-1 rounded-full bg-primary-800 text-background-100/90 text-xs"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-700 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-100/70">
            本站为信息整理类页面，不提供影片文件，不引导绕过授权的观看方式。
          </p>
          <p className="text-xs text-background-100/70">尊重版权 · 理性浏览 · 内容仅供参考</p>
        </div>
      </div>
    </footer>
  );
}